import { render } from "./Wallets.vue?vue&type=template&id=294c6d14&scoped=true"
import script from "./Wallets.vue?vue&type=script&lang=js"
export * from "./Wallets.vue?vue&type=script&lang=js"

import "./custom-wallets.scss?vue&type=style&index=0&id=294c6d14&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-294c6d14"]])

export default __exports__